import { AppBar, type AppBarProps, Box, styled, Toolbar } from '@mui/material';

import { useAppSelector } from "~/application/hooks";
import { selectIsDrawerOpen } from "~/application/slice";
import { MainDrawerToggle } from '../drawer/MainDrawerToggle';
import { UserLogout } from './widget/UserLogout';

export const MainHeader = () => {
    const drawerOpen = useAppSelector(selectIsDrawerOpen);

    return (
        <HeaderRoot color="inherit" elevation={0} open={drawerOpen}>
            <Toolbar>
                <MainDrawerToggle />
                <Box sx={{ flexGrow: 1 }} />
                <UserLogout />
            </Toolbar>
        </HeaderRoot>
    );
};

type HeaderRootProps = AppBarProps & {
    open?: boolean | undefined;
}

const HeaderRoot = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<HeaderRootProps>(
    ({ open, theme }) => ({
        width: '100%',
        zIndex: open ? theme.zIndex.drawer : theme.zIndex.drawer + 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.up('lg')]: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            ...(!open && {
                width: `calc(100% - ${theme.spacing(7.5)})`,
            }),
            ...(open && {
                marginLeft: 260,
                width: `calc(100% - 260px)`,
                zIndex: theme.zIndex.drawer,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            }),
        },
    })
);